import { useEffect } from 'react'

interface KeyCombination {
    ctrlKey?: boolean
    shiftKey?: boolean
    altKey?: boolean
    metaKey?: boolean
    key: string
}

function useKeyPress(keyCombination: KeyCombination, callback: () => void) {
    useEffect(() => {
        const keyDownHandler = (event: KeyboardEvent) => {
            const { ctrlKey = false, shiftKey = false, altKey = false, metaKey = false, key } = keyCombination

            if (
                event.ctrlKey === ctrlKey &&
                event.shiftKey === shiftKey &&
                event.altKey === altKey &&
                event.metaKey === metaKey &&
                event.key.toLowerCase() === key.toLowerCase()
            ) {
                event.preventDefault()
                callback()
            }
        }

        window.addEventListener('keydown', keyDownHandler)

        return () => {
            window.removeEventListener('keydown', keyDownHandler)
        }
    }, [keyCombination, callback])
}

export default useKeyPress
